export default function hasDrawingContext(name) {
    return (typeof window !== "undefined" &&
        window.document.createElement("canvas").getContext(name) != null);
}
